import { Link } from "react-router-dom";
import { Wallet, CheckCircle2, ArrowRight, AlertCircle } from "lucide-react";

/**
 * Gate visual mostrado cuando un host intenta publicar una plaza
 * sin tener Stripe Connect configurado.
 */
export default function StripeConnectGate({ status }) {
  const started = status?.has_account;
  return (
    <div className="min-h-screen bg-[#0f0c17] pt-24 pb-16">
      <div className="max-w-2xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8">
          <div className="inline-flex w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 items-center justify-center mb-5 shadow-xl shadow-amber-500/30 ring-1 ring-white/10">
            <Wallet className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-white tracking-tight">
            Configura tus cobros para publicar
          </h1>
          <p className="text-gray-400 mt-3 text-sm sm:text-base">
            Para evitar fraudes y que el dinero llegue directamente a tu cuenta, todos los
            anfitriones necesitan verificar su identidad con Stripe antes de publicar plazas.
          </p>
        </div>

        <div className="bg-[#15121e] border border-white/5 rounded-2xl p-6 sm:p-8 mb-6">
          <h2 className="text-white font-semibold text-base mb-4">Qué vas a hacer ahora</h2>
          <ol className="space-y-3">
            <Step n={1} text="Pulsa el botón de abajo. Te llevamos al sitio seguro de Stripe." />
            <Step n={2} text="Verifica tu identidad (DNI/NIE) y añade tu IBAN. Tarda 2-3 minutos." />
            <Step n={3} text="Volvés a Plazafy y ya podés publicar todas las plazas que quieras." />
          </ol>

          <div className="mt-6 p-4 bg-emerald-500/10 border border-emerald-500/20 rounded-xl flex items-start gap-3">
            <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
            <p className="text-emerald-200/90 text-sm leading-relaxed">
              <strong className="text-white">Solo lo haces una vez.</strong> El dinero de cada
              reserva llega automáticamente a tu cuenta, sin esperas ni transferencias manuales.
            </p>
          </div>
        </div>

        <Link
          to="/host/payments"
          className="group flex items-center justify-center gap-2 w-full px-6 py-3.5 rounded-full text-base font-semibold text-white bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-400 hover:to-orange-500 shadow-lg shadow-amber-500/30 hover:shadow-amber-500/50 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200"
          data-testid="addspot-gate-cta"
        >
          {started ? <AlertCircle className="w-5 h-5" /> : <Wallet className="w-5 h-5" />}
          {started ? "Continuar configuración" : "Configurar cobros ahora"}
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </Link>

        <p className="text-center text-gray-500 text-xs mt-4">
          Plazafy nunca ve tus datos bancarios. Todo lo gestiona Stripe, líder global en pagos.
        </p>
      </div>
    </div>
  );
}

function Step({ n, text }) {
  return (
    <li className="flex items-start gap-3">
      <span className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-br from-amber-500 to-orange-600 text-white text-xs font-semibold flex items-center justify-center shadow-md">
        {n}
      </span>
      <p className="text-gray-300 text-sm leading-relaxed flex-1">{text}</p>
    </li>
  );
}
